module.exports = __webpack_public_path__ + "assets/1a7e9a4617e7b4c5fe95e9cfd93b9124.svg";